import React from 'react'
import { Link } from 'gatsby';

import Layout from '../components/layout'

import Skills from './skills'
import Tools from './tools'
import Systems from './systems'
import ContactPage from './contactPage'

import introStyles from '../styles/components/index.module.scss'

const IndexPage = () => {
    return (
        <Layout>
                <section className={introStyles.introContainer} id ="Intro">
                    <div className={introStyles.introTopic}>
                        <h1 id='h1'>Hi!</h1>
                        <h3 id ='h3'>I'm Damian.</h3>
                        <p id ='p'>Do you need a <a href = "/cv/CV/CV-Damian_Cwykiel_PL.pdf" target="_blank" rel="noopener referrer"><span>tech support</span></a> ?</p>
                    </div>
                    <div className={introStyles.introTopic}>
                        <div className={introStyles.figure}>
                            <div className={introStyles.figure}></div>
                        </div>
                    </div>
                </section>
                <section className={introStyles.blockAbout}>
                    <div className={introStyles.img}></div>
                </section>
                <section data-about-me className = {introStyles.containerAboutMe} id ="About">
                    <div className = {introStyles.aboutMeText}>
                        <h1>ABOUT.ME</h1>
                            <p>My name is<Link a className = {introStyles.aboutMeLinks} href ="/cv/CV/CV-Damian_Cwykiel_PL.pdf" rel="noopener referrer" target="_blank"> Damian </Link></p>
                            <p>And I support technology and solve IT problems</p>
                            <p> I really like a good <a className = {introStyles.aboutMeLinks} href="https://node-forecast-app.herokuapp.com" rel="noreferrer" target="_blank"> weather </a>
                            and I try to be familiar with <a className = {introStyles.aboutMeLinks} href="https://www.centos.org/" rel="noreferrer" target="_blank"> penguins</a></p>
                            <p>I love to <Link className = {introStyles.aboutMeLinks} to ="/projectsPage"> create </Link> and explore new <a className = {introStyles.aboutMeLinks} href="https://nofluffjobs.com/pl" rel="noreferrer" target="_blank"> environments</a></p>
                            <p>I'm a power user in solving strange <a className = {introStyles.aboutMeLinks} href="https://stackoverflow.com/questions" rel="noreferrer" target="_blank"> problems </a></p>
                            <p>and just to have a good time <a className = {introStyles.aboutMeLinks} href="https://github.com/DamianCwykiel?tab=repositories" rel="noreferrer" target="_blank"> building</a></p>
                            <p>	I always enjoy to learn new <a className = {introStyles.aboutMeLinks} href="/#Skills" rel="noreferrer"> skills</a> and <a className = {introStyles.aboutMeLinks} href =" https://www.docker.com" rel="noreferrer" target="_blank"> possibilities</a></p>
                            <p>Except diving into <a className = {introStyles.aboutMeLinks} href="https://pl.reactjs.org/" rel="noreferrer" target="_blank"> websites</a> & <a className = {introStyles.aboutMeLinks} href="https://nodejs.org/en/about/" rel="noreferrer" target="_blank"> apps </a>
                            development I like <a className = {introStyles.aboutMeLinks} href ="https://ctflearn.com/challenge/1/browse" rel="noreferrer" target="_blank"> to relax </a> 
                            gaming or<a className = {introStyles.aboutMeLinks} href="https://damian-nodeproject-v3.herokuapp.com/" rel="noreferrer" target="_blank"> chatting</a></p>
                            <p>I am just the technology enthusiast</p>
                            <p>Currently, I'm seeking new job opportunities</p>
                            <p>If you need more information </p>
                            <p><a className = {introStyles.aboutMeLinks} href="/#Contact"> reach me out</a> via contact section or click for more</p>
                            <Link className={introStyles.navItemAbout} to="/aboutPage"><h2>| more |</h2></Link>
                    </div>
                </section>
                <section className = {introStyles.containerSkills} id="Skills">
                    <Skills/>
                </section>
                <section className = {introStyles.containerTools} id="Tools">
                    <Tools/>
                </section>
                <section className = {introStyles.containerSystems} id="Systems">
                    <Systems/>
                </section>
                <section className = {introStyles.containerContact} id="Contact">
                    <div className = {introStyles.contactBlock}>
                        <div className = {introStyles.contactDetails}>
                            <h2>Get In Touch</h2>
                            <p>Have a question?</p>
                            <a className = {introStyles.contactButtonLink} href = "https://gmail.com"  rel="noreferrer" target="_blank"><div className = {introStyles.contactButton}>Contact.Me.</div></a>
                        </div>
                    </div>
                </section>
                <section className = {introStyles.containerConclusion}>
                    <ContactPage />
                </section>
        </Layout>
    )
}

export default IndexPage
